<mat-chip-grid #chipList [disabled]="field.props.disabled ?? false">
  <mat-chip-row *ngFor="let value of formControl.value" (removed)="remove(value)">
    <ng-container *ngIf="field.props?.labelProp">
      {{ value[field.props.labelProp] }}
    </ng-container>
    <ng-container *ngIf="!field.props?.labelProp">
      {{ value }}
    </ng-container>

    <a href="#" matChipRemove>
      <mat-icon>cancel</mat-icon>
    </a>
  </mat-chip-row>
  <input
    matInput
    [id]="id"
    [name]="field.name!"
    [type]="'text'"
    [readonly]="props.readonly"
    [required]="required"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [matAutocomplete]="auto"
    [matChipInputFor]="chipList"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    (matChipInputTokenEnd)="add($event)"
    [hidden]="field.props.showAutoComplete === false"
  />
</mat-chip-grid>

<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
  <mat-option *ngFor="let value of filteredValues | async" [value]="value">
    <ng-container *ngIf="field.props?.labelProp">
      {{ value[field.props.labelProp] }}
    </ng-container>
    <ng-container *ngIf="!field.props?.labelProp">
      {{ value }}
    </ng-container>
  </mat-option>
</mat-autocomplete>
